/**
 * US federal holiday computation (Gregorian).
 * Returns holidays keyed as "year-month-day" (month 0-based) — same key format as CalendarPage.
 */

export function getNthWeekday(year: number, month: number, weekday: number, n: number): number {
  const first = new Date(year, month, 1).getDay();
  const offset = (weekday - first + 7) % 7;
  return 1 + offset + (n - 1) * 7;
}

export function getLastWeekday(year: number, month: number, weekday: number): number {
  const lastDay = new Date(year, month + 1, 0).getDate();
  const lastDow = new Date(year, month, lastDay).getDay();
  const offset = (lastDow - weekday + 7) % 7;
  return lastDay - offset;
}

export function getUSFederalHolidays(year: number): Map<string, string> {
  const h = new Map<string, string>();

  const add = (month: number, day: number, name: string) => {
    let d = new Date(year, month, day);
    const dow = d.getDay();
    if (dow === 6) d = new Date(year, month, day - 1);
    else if (dow === 0) d = new Date(year, month, day + 1);
    h.set(`${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`, name);
  };

  add(0, 1, "New Year's Day");
  h.set(`${year}-0-${getNthWeekday(year, 0, 1, 3)}`, 'MLK Day');
  h.set(`${year}-1-${getNthWeekday(year, 1, 1, 3)}`, "Presidents' Day");
  h.set(`${year}-4-${getLastWeekday(year, 4, 1)}`, 'Memorial Day');
  add(5, 19, 'Juneteenth');
  add(6, 4, 'Independence Day');
  h.set(`${year}-8-${getNthWeekday(year, 8, 1, 1)}`, 'Labor Day');
  h.set(`${year}-9-${getNthWeekday(year, 9, 1, 2)}`, 'Columbus Day');
  add(10, 11, 'Veterans Day');
  h.set(`${year}-10-${getNthWeekday(year, 10, 4, 4)}`, 'Thanksgiving');
  add(11, 25, 'Christmas');

  // Next year's New Year's Day is observed on Dec 31 of THIS year when Jan 1 falls on Saturday
  if (new Date(year + 1, 0, 1).getDay() === 6) {
    h.set(`${year}-11-31`, "New Year's Day");
  }

  return h;
}
